import { render, staticRenderFns } from "./salas.vue?vue&type=template&id=987de07c"
import script from "./salas.vue?vue&type=script&lang=js"
export * from "./salas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports